export enum PrintJobStatus {
  PENDING = 'PENDING',
  DISPATCHED = 'DISPATCHED',
  PRINTED = 'PRINTED',
  FAILED = 'FAILED',
  UNKNOWN = 'UNKNOWN',
  CANCELLED = 'CANCELLED',
}

export enum PrintJobType {
  TEST = 'TEST',
  BOOKING = 'BOOKING',
  TICKET = 'TICKET',
  CHECK_IN = 'CHECK_IN',
  MANUAL = 'MANUAL',
}
